import {AuthenticationRoute} from "./routes/Authentication.js";
import {CreateFlowRoute} from "./routes/CreateFlow.js";
import {FlowRoute} from "./routes/Flow.js";
const routes = [AuthenticationRoute, CreateFlowRoute, FlowRoute];
export default routes;
